import React from 'react';
import Sidebar from '../components/Sidebar';
import Topbar from '../components/Topbar';

const AdminLayout = ({ children, title, subtitle }) => (
  <div className="admin-wrapper" id="admin-wrapper">
    <Sidebar />
    <div className="admin-main" id="admin-main">
      <Topbar title={title} subtitle={subtitle} />
      <main className="admin-content" id="admin-content">
        {children}
      </main>
    </div>
  </div>
);

export default AdminLayout;
